// src/components/common/InfoGrid.jsx
import React from "react";

export function InfoGrid({ children, cols = "grid-cols-1 md:grid-cols-2", className = "" }) {
    return <div className={`grid ${cols} gap-4 ${className}`}>{children}</div>;
}

export function InfoItem({label, children, colspan = 1}) {
    return (
        <div className={`text-xl p-3 bg-gray-50 rounded col-span-${colspan}`}>
            {label && <span className="font-semibold">{label}: </span>}
            {children}
        </div>
    );
}